var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1ShutterOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 13H0v50h76V13H60zM16 52H4v-3h12v3zm0-8H4v-3h12v3zm0-8H4v-3h12v3zm0-8H4v-3h12v3zm4-11h16v42H20V17zm36 42H40V17h16v42zm16-7H60v-3h12v3zm0-8H60v-3h12v3zm0-8H60v-3h12v3zm0-8H60v-3h12v3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Shutter_open.c42e7de2.svg";
export { SvgC1ShutterOpen as ReactComponent };